export const eyesOnDataModel = () => {
    return {
        micStatus:0,
        videoStatus:0
    }
};
